export default "__VITE_ASSET__a3383c65__"